import { API_ENDPOINT_BUSINESS_TX } from '../config'
import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { buildUrl } from '../utils/helpers'

export const GET_ACCESS_CODES_REQUEST = 'GET_ACCESS_CODES_REQUEST'
export const GET_ACCESS_CODES_SUCCESS = 'GET_ACCESS_CODES_SUCCESS'
export const GET_ACCESS_CODES_FAILURE = 'GET_ACCESS_CODES_FAILURE'

const buildDataUrl = (page = 1, limit = 25, business = null, filter, sortData) => {
  let queryParams = {}

  if (page && limit) {
    const offset = (page - 1) * limit
    queryParams = { ...queryParams, ...{ page, limit, offset } }
  }

  if (filter) {
    const { is_active, code, is_notnull } = filter
    if (is_active) {
      queryParams = { ...queryParams, ...{ is_active } }
    }

    if (code) {
      queryParams = { ...queryParams, ...{ code } }
    }

    if (is_notnull === 'true') {
      queryParams = { ...queryParams, ...{ is_notnull: 'parent_code' } }
    } else if (is_notnull === 'false') {
      queryParams = { ...queryParams, ...{ is_null: 'parent_code' } }
    }
  }

  if (sortData) {
    const { field, order } = sortData
    if (field && order) {
      const ordering = order === 'asc' ? field : `-${field}`
      queryParams = { ...queryParams, ...{ ordering } }
    }
  }
  return buildUrl(`${API_ENDPOINT_BUSINESS_TX}/${business}/access-codes/`, {
    ...queryParams,
  })
}

export const getAccessCodes = (business, page, limit, filter, sortData) => ({
  [CALL_API]: {
    endpoint: buildDataUrl(page, limit, business, filter, sortData),
    types: [GET_ACCESS_CODES_REQUEST, GET_ACCESS_CODES_SUCCESS, GET_ACCESS_CODES_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
